<app-navigation></app-navigation>
<app-maintenance></app-maintenance>
<div class="mainContentFullWith unselectable">
  <div class="unselectable headerTitle headline">{{translation.DamageReports}}</div>
  <div class="breakLine"></div>
  <div id="moduleContent">
    <ejs-grid #damageAdministrationReportGrid
              id="damageAdministrationReportGrid"
              (recordDoubleClick)="openDamageAdministrationRecord($event)"
              [locale]="locale"
              [dataSource]="dataSource"
              (toolbarClick)="toolbarClick($event)"
              (rowDataBound)="rowDataBound($event)">
      <e-columns>
        <e-column field="DocNum" headerText="Nr." textAlign="Left" isPrimaryKey="true" width="90px"></e-column>
        <e-column field="DamageDate" headerText="Schadendatum" textAlign="Left" width="125px"></e-column>
        <e-column field="ReceiverDisplayName" headerText="Empfänger" textAlign="Left" width="170px"></e-column>
        <e-column field="WorkshopDisplayName" headerText="Rep. Werkstatt" textAlign="Left" width="170px"></e-column>
        <e-column field="CausedByDisplayName" headerText="Verursacher" textAlign="Left"></e-column>
        <e-column field="OwnCosts" headerText="Eigenkosten" textAlign="Right" format="N2" width="110px"></e-column>
        <e-column field="ChassisNo" headerText="Chassis Nr." textAlign="Left" width="185px"></e-column>
        <e-column field="Identification" headerText="Identifikation" textAlign="Left" width="115px"></e-column>
        <e-column field="License" headerText="Kontrollschild" textAlign="Left" width="130px"></e-column>
        <e-column field="JobTypeDisplayName" headerText="Auftragstyp" textAlign="Left" width="145px"></e-column>
        <e-column field="CreatedBy" headerText="Erstellt von" textAlign="Left" width="150"></e-column>
        <e-column field="LastChangeBy" headerText="Bearbeitet von" textAlign="Left" width="150"></e-column>
        <e-column field="CostEstimate" visible="false" width="0px"></e-column>
        <e-column field="DamageAmount" visible="false" width="0px"></e-column>
        <e-column field="InsuranceAmount" visible="false" width="0px"></e-column>
      </e-columns>
    </ejs-grid>
  </div>
</div>
<app-footer></app-footer>
